import { render, staticRenderFns } from "./WiaaCertificationLookup.vue?vue&type=template&id=14c75de3&scoped=true&"
import script from "./WiaaCertificationLookup.vue?vue&type=script&lang=js&"
export * from "./WiaaCertificationLookup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14c75de3",
  null
  
)

export default component.exports